import CustomSelect from "../shared/CustomSelect";

/** Toolbar segment: drone picker + upload-to-drone action (QGC-style states). */
function DroneUploadBar({
  drones,
  selectedDroneId,
  onDroneChange,
  onUpload,
  uploading,
  uploadDisabled,
  flight,
  disabled,
}) {
  const options = drones.map((d) => {
    const id = d.id ?? d.drone_id;
    const name = d.name || d.device_name || id;
    const battery =
      d.battery_percentage != null ? `${Math.round(d.battery_percentage)}%` : "";
    const busy = d.is_in_flight || d.is_available === false;
    return {
      value: id,
      label: (
        <span className="cs-drone-option">
          <span className="cs-connected-dot" />
          <span>{name}</span>
          {battery && <span className="cs-drone-meta">{battery}</span>}
          {busy && <span className="cs-drone-meta cs-busy">in use</span>}
        </span>
      ),
      disabled: busy,
    };
  });

  const uploaded = flight?.status === "uploaded" && !uploading;
  const wpCount = flight?.total_waypoints;

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <div style={{ minWidth: 240 }}>
        <CustomSelect
          value={selectedDroneId}
          onChange={onDroneChange}
          disabled={disabled}
          options={
            options.length
              ? [{ value: "", label: "Select drone\u2026" }, ...options]
              : [{ value: "", label: "No drones connected" }]
          }
        />
      </div>
      <button
        className={`cs-btn primary ${uploaded ? "uploaded" : ""}`}
        onClick={onUpload}
        disabled={uploading || uploadDisabled || !selectedDroneId || disabled}
        title={
          disabled
            ? "Select a project first"
            : uploadDisabled
            ? "Fix plan errors before uploading"
            : uploaded
            ? "Mission is on the vehicle \u2014 click to re-upload"
            : "Upload mission to drone"
        }
      >
        {uploading
          ? "\u21E7 Uploading\u2026"
          : uploaded
          ? `\u2713 On drone${wpCount ? ` (${wpCount} WP)` : ""} \u2014 Re-upload`
          : "\u21E7 Upload"}
      </button>
    </div>
  );
}

/** Bottom strip showing live survey-flight status from WebSocket events. */
export function FlightStatusStrip({ flight }) {
  return (
    <div className="cs-upload-strip">
      <strong style={{ fontSize: 12 }}>Survey flight:</strong>
      {flight?.status ? (
        <span className={`cs-upload-badge ${flight.status}`}>{flight.status}</span>
      ) : (
        <span className="cs-hint">not uploaded</span>
      )}
      {flight?.current_waypoint != null && flight?.total_waypoints != null && (
        <span style={{ fontSize: 12 }}>
          WP {flight.current_waypoint}/{flight.total_waypoints}
        </span>
      )}
      {flight?.message && <span className="cs-hint">{flight.message}</span>}
    </div>
  );
}

export default DroneUploadBar;
